export const fetchText = async (url, options = {}) => {
  const response = await fetch(url, options);
  return response.text();
};
